/* eslint-disable no-shadow */
import axiosUserInstance from '@/helpers/http-common';

const state = () => ({
  redeemTiers: null,
  timestamp: null,
});

// getters
const getters = {
};

  // actions
const actions = {
  init({ commit, dispatch }) {
    const cachedTiers = JSON.parse(localStorage.getItem('redeemTiers'));

    if (cachedTiers && new Date() <= cachedTiers.timestamp) {
      commit('updateTiers', { redeemTiers: cachedTiers.redeemTiers, timestamp: cachedTiers.timestamp });
    } else {
      // expired or missing tiers
      dispatch('fetchRedeemTiers');
    }
  },
  loadRedeemTiers({ state, dispatch }) {
    if (!state.redeemTiers || !state.timestamp) {
      dispatch('init');
    } else if (new Date() > state.timestamp) {
      // expired tiers
      dispatch('fetchRedeemTiers');
    }
  },
  fetchRedeemTiers({ commit }) {
    commit('loadingTiers', true);

    axiosUserInstance.get('redeem-tiers')
      .then((response) => {
        const currentDate = new Date();
        const expirationCacheDate = currentDate.setTime(
          // eslint-disable-next-line comma-dangle
          currentDate.getTime() + (1 * 60 * 60 * 1000)
        );

        localStorage.setItem('redeemTiers', JSON.stringify({ redeemTiers: response.data.redeem_tiers, timestamp: expirationCacheDate }));
        commit('updateTiers', { redeemTiers: response.data.redeem_tiers, timestamp: expirationCacheDate });
      })
      .catch(() => {
        throw new Error('Αποτυχία φόρτωσης επιπέδων εξαργύρωσης.');
      });
  },
};

  // mutations
const mutations = {
  loadingTiers(state, loadingTiers = true) {
    state.loadingTiers = loadingTiers;
  },
  updateTiers(state, { redeemTiers, timestamp }) {
    state.redeemTiers = redeemTiers;
    state.timestamp = timestamp;
    state.loadingTiers = false;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/loyaltyTiers.js